import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card mb-4" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "alert alert-info d-flex justify-content-between align-items-center" }
const _hoisted_9 = { class: "h3 mb-0" }
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-md-6 col-lg-4 mb-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-6 col-lg-4 mb-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-md-6 col-lg-4 mb-2" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table table-bordered table-striped" }
const _hoisted_18 = { class: "text-nowrap" }
const _hoisted_19 = { class: "text-nowrap" }
const _hoisted_20 = { class: "text-nowrap" }
const _hoisted_21 = { class: "text-nowrap" }
const _hoisted_22 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { useToast } from 'vue-toast-notification'
import { jsonToExcel } from "@/util/makeExcel"

interface SiddarSummary {
  month: number
  year: number
  siteName: string
  department: string
  numberOfSiddar: number
  monthName: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'siddar-summary-report',
  setup(__props) {

const $toast = useToast()

const summaryData = ref<SiddarSummary[]>([])
const selectedMonth = ref<number | ''>('')
const selectedYear = ref<number>(new Date().getFullYear())
const siteSearch = ref('')

const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
]

const currentYear = new Date().getFullYear()
const years = Array.from({ length: 5 }, (_, i) => currentYear + i)
const baseUrl = process.env.VUE_APP_BASE_URL

const filteredData = computed(() => {
  return summaryData.value.filter((item) => {
    // Month filter
    const monthMatch = !selectedMonth.value || item.month === selectedMonth.value

    // Year filter
    const yearMatch = item.year === selectedYear.value

    // Site name filter
    const siteMatch = !siteSearch.value || 
      item.siteName.toLowerCase().includes(siteSearch.value.toLowerCase())

    return monthMatch && yearMatch && siteMatch
  })
})

const getCurrentMonthName = computed(() => {
  const currentMonth = new Date().getMonth() + 1
  return months.find(m => m.value === currentMonth)?.label || ''
})

const currentMonthTotal = computed(() => {
  const currentMonth = new Date().getMonth() + 1
  return filteredData.value
    .filter(item => item.month === currentMonth)
    .reduce((total, item) => total + item.numberOfSiddar, 0)
})

const fetchSiddarSummary = async () => {
  try {
    const response = await axios.get(`${baseUrl}api/siddar/summary`)
    summaryData.value = response.data
    if (summaryData.value.length === 0) {
      $toast.info('No Siddar summary data found')
    }
  } catch (error) {
    console.error('Error fetching Siddar summary:', error)
    $toast.error('Failed to fetch Siddar summary data')
  }
}

const clearFilters = () => {
  selectedMonth.value = ''
  selectedYear.value = new Date().getFullYear()
  siteSearch.value = ''
}

const downloadExcel = () => {
  const dataToExport = filteredData.value.map((item, index) => ({
    'SL': index + 1,
    'Month': item.monthName,
    'Site Name': item.siteName,
    'Department': item.department,
    'No of Siddar': item.numberOfSiddar
  }))

  const timestamp = new Date().toISOString().split('T')[0]
  jsonToExcel(dataToExport, `siddar-summary-report-${timestamp}.xlsx`)
  $toast.success('Excel file downloaded successfully')
}

onMounted(() => {
  fetchSiddarSummary()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4" }, [
          _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "card-title" }, "Siddar Summary Report", -1)),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: downloadExcel
          }, " Download Excel ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "card-subtitle mb-3" }, "Current Month Summary", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(getCurrentMonthName.value) + " " + _toDisplayString(selectedYear.value), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-1" }, "Total Siddar Count", -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(currentMonthTotal.value), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label" }, "Month", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMonth).value = $event)),
              class: "form-select"
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "All Months", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month) => {
                return _createElementVNode("option", {
                  key: month.value,
                  value: month.value
                }, _toDisplayString(month.label), 9, _hoisted_12)
              }), 64))
            ], 512), [
              [_vModelSelect, selectedMonth.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Year", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedYear).value = $event)),
              class: "form-select"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(years), (year) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: year,
                  value: year
                }, _toDisplayString(year), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedYear.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Site Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((siteSearch).value = $event)),
              placeholder: "Search by site name"
            }, null, 512), [
              [_vModelText, siteSearch.value]
            ])
          ])
        ]),
        _createElementVNode("div", { class: "row mb-4" }, [
          _createElementVNode("div", { class: "col" }, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: clearFilters
            }, " Clear Filters ")
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "bg-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "text-nowrap" }, "Month"),
                _createElementVNode("th", { class: "text-nowrap" }, "Site Name"),
                _createElementVNode("th", { class: "text-nowrap" }, "Department"),
                _createElementVNode("th", { class: "text-nowrap" }, "No of Siddar")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(item.monthName), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(item.siteName), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(item.department), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(item.numberOfSiddar), 1)
                ]))
              }), 128)),
              (!filteredData.value.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _cache[10] || (_cache[10] = [
                    _createElementVNode("td", {
                      colspan: "4",
                      class: "text-center"
                    }, "No data available", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})